import React, { Component, useEffect } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

import Body from '../Components/layout/Body';
import OtherTextInput from '../Components/layout/OtherTextInput';
import { ENVIRONMENT_BUTTONS } from './ConstEnvironmentBtns';
import { OTHER_CKBX_VAL, isOtherChecked } from './OtherCheckboxUtils';

const ENVIRONMENTS_HELP = `
  <div>
    <p><strong>Purpose:</strong> Physical environments may create some challenges or constraints for an access solution.  
    For example, if the client needs access in a lot of environments, you’ll need to decide how to provide access in each location: 
    perhaps with one highly portable solution that moves from place to place, or perhaps with a couple of separate workstations, or a combination of the two.</p>
    <p>Certain environmental characteristics may be important for specific access methods. 
    For example, using speech recognition in a noisy environment may be more difficult than in a quiet one. 
    Using eyegaze in a sunny area may not always work well.  For issues such as these, you may want to have a backup plan.</p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  environments: PropTypes.arrayOf(PropTypes.string),
  onChangeEnvironments: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  environments: []
};

//content sub-component with unique content for this page
class ContextsEnvironmentsContent extends Component {
  constructor(props){
    super(props);
  }

  //Render the form for the environments.
  //Calls the setter that's passed in by the parent, when a checkbox is clicked.
  //That setter changes the state of the environments var in the parent, 
  //which triggers a new render of the view with the new goal.

  render(){
    const environments = this.props.environments ?? [];
    const onChangeEnvironments= this.props.onChangeEnvironments;
    console.log("rendering GatherInfoContextsEnvironments with environments: " + environments);

    const otherEnvironment = this.props.otherEnvironment;
    const onChangeOtherEnvironment = this.props.onChangeOtherEnvironment;

    let activeBtns = ENVIRONMENT_BUTTONS; 
    let otherChecked = isOtherChecked(environments);

    return(
    <>
    <Form>
      <FormGroup tag="fieldset">
        <legend>Check all that apply:</legend>
        {activeBtns.map((btn, index) =>
          <React.Fragment key={index}>
          <FormGroup check>
            <Input
              id={btn.value}
              value={btn.value}
              checked={environments.findIndex( (env) => env.startsWith(btn.value)) > -1}
              onChange={onChangeEnvironments} 
              name="environment"
              type="checkbox"
            />
            {' '}
            <Label for={btn.value} check>
              {btn.label}
              {' '}
              <span className="aa-more-info">{btn.moreInfo}</span>
            </Label>
          </FormGroup>
          {/* If the btn is 'other', include a text field to specify */}
          { ((btn.value === OTHER_CKBX_VAL)) 
            ?
            <OtherTextInput
              otherChecked={otherChecked}
              otherText={otherEnvironment}
              onChangeOtherText={onChangeOtherEnvironment}
            />
            : null
          }
          </React.Fragment>
        )}
      </FormGroup>
    </Form>
    </>
  );
}
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component.
//since the main goal step includes a form, receive the initial form values via props,
//along with setters to change those values based on the form input.
function GatherInfoContextsEnvironments(props) {
  const firstName = props.firstName;
  const environments = props.environments;
  const onChangeEnvironments = props.onChangeEnvironments;
  const otherEnvironment = props.otherEnvironment;
  const onChangeOtherEnvironment = props.onChangeOtherEnvironment;
  const saveFormData = props.saveFormData;
  const onContinue = props.onContinue;

  console.log("rendering GatherInfoContextsEnvironments, environments: " + environments);

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-users",
    pageSymbolClassName: "aa-section-symbol gather",

    title: `What are the main environments where ${firstName} needs access?`,
    subTitle: '',
    learnMore: {linkText: "Learn More about why we ask about environments",
                title: "Environments",
                content: ENVIRONMENTS_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true
  }

  useEffect(() => {
    console.log('GIGEnvironments mounted');
    return () => {
      console.log('GIGEnv unmounting and saving...');
      saveFormData();
    }
  }, [saveFormData])

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <ContextsEnvironmentsContent 
          environments={environments} 
          onChangeEnvironments={onChangeEnvironments}
          otherEnvironment={otherEnvironment}
          onChangeOtherEnvironment={onChangeOtherEnvironment}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoContextsEnvironments.propTypes = propTypes;
GatherInfoContextsEnvironments.defaultProps = defaultProps;

export default GatherInfoContextsEnvironments;